/*

  setListener
  ---
  na item nastavuje posluchač a třídu

  setListeners
  ---
  prochází itemy a spouští na nich setListener

  setListenersFromSelector
  ---
  selectuje itemy a spouští na nich setListener nebo setListeners

  **
    PŘÍKLAD
  **

  let ratingLinks = setListenersFromSelector(
    '.item-selector', // selector na itemy
    'init-class', // initializacni class (kvuli zachovani jednoho eventu)
    function() {}, // event funkce pro posluchac
    false, // multiple (zda ma pouzit querySelector nebo querySelectorAll)
    'change', // jaky event ma poslouchat
    wrapper // pripadny wrapper (document.body treba)
  );
*/

import logger from '../functions/logger';
import {
  querySelectorAll,
  querySelector
} from '../functions/querySelectors';

export function setListener(item, callback, initClass, event = 'click') {
  try {
    let options = {};

    if (event === 'touchstart') {
      options = {
        passive: true
      };
    }

    item.addEventListener(event, callback, options);

    if (initClass) {
      item.classList.add(initClass);
    }
  }
  catch (e) {
    logger(e);
  };
}

export function setListeners(items, callback, initClass, event = 'click') {
  try {
    items.forEach((item) => {
      setListener(item, callback, initClass, event);
    });
  }
  catch (e) {
    logger(e);
  };
}

export function setListenersFromSelector(selector, initClass, callback, multiple = true, event = 'click', wrapper = document) {
  let sel = selector;

  if (initClass) {
    sel = `${selector}:not(.${initClass})`;
  }

  if (multiple) {
    let items = querySelectorAll(sel, wrapper);

    if (items.length) {
      setListeners(items, callback, initClass, event);
      return items;
    }
  }
  else {
    let item = querySelector(sel, wrapper);

    if (item) {
      setListener(item, callback, initClass, event);

      return item;
    }
  }

  logger(`No item found on selector "${selector}:not(.${initClass})" (multiple = ${multiple}).`);
  return (multiple ? [] : null);
}
